import { isAxiosError } from 'axios';
import { redirect } from '@tanstack/react-router';

/**
 * Route loaders that prefetch a class should not surface CrashScreen when the
 * class was hard-deleted (e.g. session rollover undo). Send users to All Classes.
 */
export function redirectIfClassMissing(error: unknown): never | void {
  if (isAxiosError(error) && error.response?.status === 404) {
    throw redirect({ to: '/classes' });
  }
}
